export default __webpack_public_path__ + "static/media/SCANIA_HABITOS_DE_CONDUCCION_CAMIONES_W.a2caee64.pdf";